import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { CSATChromePreview } from 'components/settings/components/sections/satisfaction/components/ChatCSAT/CSATChromePreview/CSATChromePreview';
import { CSATWidgetMessage } from 'components/settings/components/sections/satisfaction/components/ChatCSAT/CSATWidgetMessage/CSATWidgetMessage';
import { RatingPreview, } from 'components/settings/components/sections/satisfaction/components/ChatCSAT/RatingPreview/RatingPreview';
export const CSATRatingPreview = ({ className, question, ratingStyle, }) => {
    return (_jsx(CSATChromePreview, Object.assign({ className: className }, { children: _jsx(CSATWidgetMessage, { children: _jsx(RatingPreview, { question: question, ratingStyle: ratingStyle }) }) })));
};
